import { type ReactNode } from 'react';

import { AppContext, initializeContext } from '@context';
import { ReleaseRefreshGuard } from './release-refresh-guard';

export const AppRootContextProvider = ({ children }: { children?: ReactNode }) => {
	const context = initializeContext();
	// console.log('render:AppRootContextProvider');
	return (
		<AppContext.Provider value={context}>
			<ReleaseRefreshGuard />
			{children}
		</AppContext.Provider>
	);
};
